module.exports = __webpack_public_path__ + "img/how-to-favourite.2.83a7903.gif";